module.exports = __webpack_public_path__ + "static/media/image-second-strip.8170d7e0.svg";